import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useRef, useEffect, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import { useCollapsibleContext } from './CollapsibleContext.js';
import collapsibleStyleObject from '../../styles/collapsible.js';
import { dlsGray01Bg } from '../../styles/colorsDls/dlsGray01Bg.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CollapsibleContent = function CollapsibleContent(_ref) {
  var labelledBy = _ref.labelledBy,
      theme = _ref.theme,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["labelledBy", "theme", "children"]);

  var _useCollapsibleContex = useCollapsibleContext(),
      openAccordions = _useCollapsibleContex.openAccordions;

  var contentRef = useRef(null);
  var isOpen = openAccordions[labelledBy];

  var handleResize = function handleResize() {
    if (contentRef.current && contentRef.current.offsetHeight > 0) {
      var newHeight = contentRef.current.scrollHeight;
      contentRef.current.style.maxHeight = "".concat(newHeight, "px");
    }
  };

  useEffect(function () {
    var maxHeight = isOpen && contentRef.current ? contentRef.current.scrollHeight : 0;
    contentRef.current.style.maxHeight = "".concat(maxHeight, "px");
    window.addEventListener('resize', handleResize);
    window.addEventListener('collapsibleDynamicResize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('collapsibleDynamicResize', handleResize);
    };
  }, [isOpen]);
  var styleObject = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, collapsibleStyleObject.accordionContent), dlsGray01Bg), {}, {
      maxHeight: 0
    });
  }, []);
  return jsx("div", _extends({
    ref: contentRef,
    "aria-labelledby": labelledBy,
    css: _objectSpread(_objectSpread({}, styleObject), theme)
  }, otherProps), children);
};

CollapsibleContent.defaultProps = {
  theme: undefined,
  children: null
};

export default CollapsibleContent;
